import Link from "next/link";
import { Chip } from "../chip";
import { CreatorAvatar } from "./creator-avatar";
import { Typography } from "../typography";

type Props = {
  name: string;
  avatarSrc?: string | null;
  tiktokHandle?: string | null;
  instagramHandle?: string | null;
  bio: string;
  niches: string[];
  href: string;
};

const cardClassName =
  "flex flex-col gap-3 rounded-2xl border border-[#e1e6f0] bg-white p-3 transition-colors hover:border-dark hover:bg-white hover:shadow-sm sm:flex-row sm:gap-3";

/**
 * Creator card used across playlist, similar-creators sections, and CMS article embeds.
 */
export const CreatorCard = ({
  href,
  avatarSrc,
  name,
  tiktokHandle,
  instagramHandle,
  bio,
  niches,
}: Props) => (
  <Link href={href} className={cardClassName}>
    <CreatorAvatar creatorSrc={avatarSrc} size="md" className="shrink-0" />
    <div className="flex flex-1 flex-col gap-2">
      <div className="space-y-0.5">
        <Typography size="lg" weight="semibold" color="black">
          {name}
        </Typography>
        <Typography as="p" size="sm" color="neutral">
          {tiktokHandle && (
            <>
              TikTok{" "}
              <Typography as="span" size="sm" weight="semibold" color="action">
                @{tiktokHandle.replace(/^@+/, "")}
              </Typography>
            </>
          )}
          {tiktokHandle && instagramHandle && " · "}
          {instagramHandle && (
            <>
              Instagram{" "}
              <Typography as="span" size="sm" weight="semibold" color="action">
                @{instagramHandle.replace(/^@+/, "")}
              </Typography>
            </>
          )}
        </Typography>
      </div>
      {bio && (
        <Typography size="sm" color="primary">
          {bio}
        </Typography>
      )}
      {niches.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {niches.map((niche) => (
            <Chip key={niche}>{niche}</Chip>
          ))}
        </div>
      )}
    </div>
  </Link>
);
